import React, { useEffect, useState } from "react";

import { getWeather as getRawWeather } from "../../../utils/server/OpenWeatherMap";
import { getTimeString } from "./getTimeString";

import weather from "./Weather.module.scss";

const getWeather = async () => {
    const serverData = await getRawWeather();

    if (typeof serverData === "string") {
        return {
            isLoading: false,
            isSucces: false,
            error: serverData,
        };
    }

    return {
        isLoading: false,
        isSucces: true,
        temperature: Math.round(serverData.main.temp),
        iconSrc: `https://openweathermap.org/img/wn/${serverData.weather[0].icon}@2x.png`,
        description: serverData.weather[0].icon.description,
        sunrise: new Date(serverData.sys.sunrise * 1000),
        sunset: new Date(serverData.sys.sunset * 1000),
    };
};

export const Weather = () => {
    const [data, setData] = useState({ isLoading: true });

    useEffect(() => getWeather().then((data) => setData(data)), []);

    return (
        <p className={weather.BLOCK}>
            {data.isLoading && <span>Loading..</span>}

            {!data.isLoading && !data.isSucces && <span>Error</span>}

            {!data.isLoading && data.isSucces && (
                <span className={weather.wrapper}>
                    <span className={weather.temperatureRow}>
                        <img
                            className={weather.icon}
                            src={data.iconSrc}
                            alt={data.description}
                        />
                        <span className={weather.tempText}>
                            {data.temperature} °C
                        </span>
                    </span>
                    <span className={weather.sunInfo}>
                        sunrise: {getTimeString(data.sunrise)}
                        &nbsp;|&nbsp;sunset: {getTimeString(data.sunset)}
                    </span>
                </span>
            )}
        </p>
    );
};
